import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actualizarMensaje } from "../../redux/actions/actGlobal";

import LayoutModulo from "./components/LayoutModulo";
import GridOpciones from "./components/GridOpciones";
import ProcesosAprendizaje from "./ProcesosAprendizaje";
import Solicitudes from "./Solicitudes";
import { Cargando } from "./components/Estados";

import { useModulo } from "./hooks/useModulo";
import { RUTA_BIBLIOTECA, VISTA_SOLICITANTE } from "./constants";
import { MENU_SOLICITANTE, PROCESOS, PROCESO_APRENDIZAJE } from "./catalogo";

/** Pantalla del solicitante: estudiante, docente o administrador. */
const Biblioteca = () => {
  const dispatch = useDispatch();
  const usuario = useSelector(({ redGlobal }) => redGlobal.usuario);

  useModulo(RUTA_BIBLIOTECA, "Biblioteca");

  const [vista, setVista] = useState(VISTA_SOLICITANTE.PROCESOS);
  const [proceso, setProceso] = useState(null);

  const onMensaje = useCallback(
    (titulo, tipo = "info") =>
      dispatch(actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 })),
    [dispatch],
  );

  const cambiarVista = (codigo) => {
    setVista(codigo);
    setProceso(null);
  };

  const contenido = () => {
    // Nada consulta hasta que hay sesion: abierta mientras se inicia sesion,
    // las consultas sin token fallaban y la tabla no cargaba (2026-10-14).
    // El key vuelve a consultar si cambia la cuenta.
    if (!usuario?.correo) return <Cargando />;

    // Procesos: la tabla con sus filtros; arranca en las solicitadas.
    if (vista === VISTA_SOLICITANTE.PROCESOS) {
      return <Solicitudes key={usuario.correo} usuario={usuario} onMensaje={onMensaje} />;
    }

    if (proceso === PROCESO_APRENDIZAJE) {
      return (
        <ProcesosAprendizaje
          usuario={usuario}
          onMensaje={onMensaje}
          // Al guardar, se lleva al usuario a Procesos para que la vea.
          onCreada={() => cambiarVista(VISTA_SOLICITANTE.PROCESOS)}
          volver={() => setProceso(null)}
        />
      );
    }

    return (
      <GridOpciones
        opciones={PROCESOS}
        onSeleccionar={({ codigo }) => setProceso(codigo)}
      />
    );
  };

  return (
    <LayoutModulo
      opciones={MENU_SOLICITANTE}
      seleccion={vista}
      onSeleccionar={cambiarVista}
    >
      {contenido()}
    </LayoutModulo>
  );
};

export default Biblioteca;
